// extracted by mini-css-extract-plugin
export var button = "_nr-1";
export var container = "_nr-0";